import { useMemo } from 'react';
import { isEmptyString } from 'utils/stringHelpers';
import { useSortingContext } from 'utils/contexts/sorting';
import { usePaginationContext } from 'utils/contexts/pagination';
import { useFiltersContext } from '../../contexts';

const nullIfEmptyArray = <T>(data: T[]) => (Boolean(data.length) ? data : null);

export const useListsVariables = ({
  rootFolderId,
  folderId,
}: Partial<{ rootFolderId: number; folderId: number }>) => {
  const { pageSize, currentPage } = usePaginationContext();
  const { sortDirection, sortBy } = useSortingContext();
  const { search, types: listTypes, listIds } = useFiltersContext();

  return useMemo(
    () => ({
      sort: { sortBy, sortDirection },
      pagination: { offset: (currentPage - 1) * pageSize, limit: pageSize },
      search: isEmptyString(search) ? null : search,
      // returning null if the folderId is the same as the rootFolderId
      folderId: folderId !== rootFolderId ? folderId : null,
      recursive: search.length > 0,
      listFilterInfo: {
        listType: nullIfEmptyArray(listTypes),
        listIds: nullIfEmptyArray(listIds),
      },
    }),
    [
      pageSize,
      currentPage,
      sortDirection,
      sortBy,
      search,
      listTypes,
      folderId,
      rootFolderId,
      listIds,
    ],
  );
};
